module.exports = __webpack_public_path__ + "static/img/showroom2.674b29b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom2.png
// module id = 8o0S
// module chunks = 2